import React, { useState } from 'react';
import { useLanguage } from './LanguageContext';
import { Send, AlertCircle } from 'lucide-react';
export function ContactForm() {
  const {
    t
  } = useLanguage();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitted(true);
    }, 1500);
  };
  if (submitted) {
    return <div className="bg-green-50 p-8 rounded-2xl text-center border border-green-100 h-full flex flex-col items-center justify-center" data-id="element-1">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4" data-id="element-2">
          <Send className="w-8 h-8 text-green-600" data-id="element-3" />
        </div>
        <h3 className="text-2xl font-bold text-green-800 mb-2" data-id="element-4">
          Message Sent!
        </h3>
        <p className="text-green-700" data-id="element-5">
          Thank you for reaching out. We will contact you shortly.
        </p>
        <button onClick={() => setSubmitted(false)} className="mt-6 text-green-700 font-semibold hover:text-green-900 underline" data-id="element-6">
          Send another message
        </button>
      </div>;
  }
  return <form onSubmit={handleSubmit} className="bg-white p-8 rounded-2xl shadow-lg border border-gray-100" data-id="element-7">
      <h3 className="text-2xl font-bold text-brand-deep mb-6" data-id="element-8">
        {t('contact.title')}
      </h3>

      <div className="space-y-4" data-id="element-9">
        <div data-id="element-10">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-11">
            {t('contact.form.name')}
          </label>
          <input type="text" id="name" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-teal focus:border-transparent outline-none transition-all" placeholder="John Doe" data-id="element-12" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-13">
          <div data-id="element-14">
            <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-15">
              {t('contact.form.phone')}
            </label>
            <input type="tel" id="phone" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-teal focus:border-transparent outline-none transition-all" placeholder="(555) 123-4567" data-id="element-16" />
          </div>
          <div data-id="element-17">
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-18">
              {t('contact.form.email')}
            </label>
            <input type="email" id="email" required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-teal focus:border-transparent outline-none transition-all" placeholder="john@example.com" data-id="element-19" />
          </div>
        </div>

        <div data-id="element-20">
          <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-21">
            {t('contact.form.message')}
          </label>
          <textarea id="message" rows={4} required className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-brand-teal focus:border-transparent outline-none transition-all resize-none" placeholder="How can we help you?" data-id="element-22"></textarea>
        </div>

        <div className="bg-red-50 border border-red-100 rounded-lg p-3 flex items-start gap-3 text-sm text-red-700" data-id="element-23">
          <AlertCircle className="w-5 h-5 flex-shrink-0 mt-0.5" data-id="element-24" />
          <p data-id="element-25">{t('contact.emergency')}</p>
        </div>

        <button type="submit" disabled={isSubmitting} className={`w-full bg-brand-teal hover:bg-brand-deep text-white font-bold py-4 rounded-xl transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2 ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`} data-id="element-26">
          {isSubmitting ? 'Sending...' : <>
              <Send className="w-5 h-5" data-id="element-27" />
              {t('contact.form.submit')}
            </>}
        </button>
      </div>
    </form>;
}